import React, { useEffect, useState } from "react";
import { useNavigate,useLocation } from "react-router-dom";
import EmailImage from '../../../assests/images/Icon zocial-email.svg'
import PhoneImage from '../../../assests/images/Icon awesome-phone-alt.svg'
import { useAuth } from "../../../user/context/AuthContext";
import Lmslogo from '../../../assests/images/logo.png'
import ProfileMenu from "../../../components/ProfileSection/ProfileMenu";
import facebookImg from '../../../assests/images/Facebook.svg'
import instagram from '../../../assests/images/insta.svg'
import youtube from '../../../assests/images/youtube.svg'
import linkedin from '../../../assests/images/linkd.svg'
import { DownOutlined, MenuOutlined } from "@ant-design/icons";
import { Button, Drawer, Dropdown } from "antd";

const Navbar = () => {

  const path = useLocation()
  const { isAuthenticated,confirmLogout} = useAuth();
  const navigate = useNavigate()
  const [open, setOpen] = useState(false);

    //calculate window inner widht here
     const [width, setWidth] = useState(window.innerWidth);
  
    useEffect(() => {
      const handleResize = () => setWidth(window.innerWidth);
      
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);
  

  const navigateToSignup = () => {
   navigate("/signup");
 };
 const contactPage = () => {
   navigate("/contact");
 };
 const handleCourse = () => {
  setOpen(false)
   navigate("/courses");
 };
 const handleMyCourse = () => {
  setOpen(false)
   navigate("/user/my-courses");
 };
 const handlePolicy = () => {
   navigate("/privacy_policy");
 };
  const handleLogout = () => {
    confirmLogout()
  }
 const handleSignInClick = () => {
  navigate("/signin");
};
const handleSignUpClick = () => {
  navigate("/signup");
};
 const handleHome = () => {
  setOpen(false)
   navigate("/");
 };
 const handleTerms = () => {
   navigate("/terms_and_conditions");
 };
 const handleLogo = () => {
   navigate("/");
 };

 const handleWishlist = () => {
  setOpen(false)
  navigate("/user/my-wishlist")
 }

 const handleMessage = () => {
  setOpen(false)
  navigate("/user/messages")
 }

 const handleProfile = () => {
  setOpen(false)
  navigate("/user/user-profile")
 }

 const handleAccount = () => {
  setOpen(false)
  navigate("/user/account")
 }


  return (
    <>
      <header>
        {/* Top Contact Bar */}
        <header className="contact-bar">
          <div className="contact-container">
            <div className="contact-info">
              <img
                src={PhoneImage}
                alt="Phone Icon"
                className="icon"
              />
              {/* <img
                src={facebookImg}
                alt="Phone Icon"
                className="icon"
                style={{backgroundColor:'white'}}
              /> */}
              <span className="phone-number">91-1234567890</span>
              <img
                src={EmailImage}
                alt="Email Icon"
                className="icon"
              />
              <a href="mailto:admissions@example.com" className="email-link">
                admissions@example.com
              </a>
            </div>
          </div>
          <div style={{display:'flex',gap:'10px'}}>
              <img
                src={facebookImg}
                alt="Email Icon"
                style={{backgroundColor:'white'}}
              />
              <img
                src={instagram}
                alt="Email Icon"

              />
              <img
                src={youtube}
                alt="Email Icon"

              />
              <img
                src={linkedin}
                alt="Email Icon"
              />
          </div>
        </header>
      
        {/* Navigation Bar */}
        <div className="nav-container">
          <img
            src={Lmslogo}
            alt="LMS Logo"
            className="logo cursor-pointer"
            onClick={handleLogo}
          />
      
          <nav className="main-nav desktop-nav">
            <div className="nav-group">
              <a onClick={handleHome} className="nav-item cursor-pointer">
                Home
              </a>
              <a onClick={handleMyCourse} className="nav-item cursor-pointer">
                My Courses
              </a>
            </div>
            <div className="nav-group">
              <a onClick={handleCourse} className="nav-item cursor-pointer">
                Courses
              </a>
              <a onClick={contactPage} className="nav-item cursor-pointer">
                Contact us
              </a>
            </div>
          </nav>

          {
                width <= 768 &&   
                <MenuOutlined onClick={() => setOpen(true)} />
              
          }

           <Drawer
                  placement="right"
                  onClose={() => setOpen(false)}
                  open={open}
                >
                  <a onClick={handleHome} className="sidebar_content">Home</a><br />
                  <a onClick={handleMyCourse} className="sidebar_content">My Courses</a><br />
                  <a onClick={handleCourse} className="sidebar_content" >Courses</a><br />
                  <a onClick={contactPage} className="sidebar_content">Contact us</a><br />
                  {!isAuthenticated() ? (
                    <div>
                      <button onClick={handleSignInClick} className="sidebar_content signin-button">Sign In</button>
                      <br />
                      <button onClick={handleSignUpClick} className="sidebar_content signout-button">Sign Up</button>
                    </div>
                  ) : (
                    <div>
                      <a onClick={handleWishlist} className="sidebar_content">My wishlist</a><br />
                      <a onClick={handleMessage} className="sidebar_content">My messages</a><br />
                      <a onClick={handleProfile} className="sidebar_content">My profile</a><br />
                      <a onClick={handleAccount} className="sidebar_content">Account</a><br />
                      <button onClick={handleLogout} className="sidebar_content logout-button">Logout</button>
                    </div>
                  )}
            </Drawer>

      
          {/* Auth or Profile */}
          <div className="auth-container desktop-nav">
          <div>
                {isAuthenticated() ? (
                  <div className="navbar_right">
                    <ProfileMenu />
                  </div>
                ) : (
                  <div className="dropdown">
                    <button className="dropdown-toggle">Sign In / Sign Up ▾</button>
                    <div className="dropdown-menu">
                      <span className="dropdown-item" onClick={handleSignInClick}>
                        Sign In
                      </span>
                      <span className="dropdown-item" onClick={handleSignUpClick}>
                        Sign Up
                      </span>
                      <a
                        href="https://adminpanel.taggeo.in/login"
                        target="_blank"
                        className="dropdown-item"
                      >
                        Admin Login
                      </a>
                    </div>
                  </div>
                )}
              </div>
          </div>
        </div>
      </header> 
    </>
  );
};

export default Navbar;
